import _get from 'lodash/get'
import _size from 'lodash/size'
import { fromJS } from 'immutable'
import { SET_USER } from 'services/user/redux/actions'
import {
  STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENTS,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL,
  STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS,
} from 'services/store-keys'
import {
  PLAN_THREE_MONTH,
  PLAN_DISCOUNTED_LIVE_ACCESS,
  PLAN_COMP,
  PLAN_DECLINE_303,
  PLAN_SUMMIT_ANNUAL,
  PLAN_SUMMIT_ANNUAL_2,
  PLAN_SUMMIT_ANNUAL_3,
  PLAN_SUMMIT_MONTHLY,
  PLAN_ONE_MONTH_TRIAL_TO_ANNUAL,
  PLAN_ONE_DOLLAR_THIRTY_DAYS_TO_MONTHLY,
  PLAN_SEVEN_DAY_MONTHLY_FREE_TRIAL_N24,
  PLAN_MONTHLY_N24,
  PLAN_SEVEN_DAY_ANNUAL_FREE_TRIAL_N24,
  PLAN_ANNUAL_N24,
  PLAN_ANNUAL_N26,
  PLAN_LIVE_ACCESS_N24,
  PLAN_YI_ONE_WEEK_TRIAL_TO_MONTHLY_BASIC,
  PLAN_YI_ONE_WEEK_TRIAL_TO_ANNUAL_BASIC,
  PLAN_YI_MONTHLY_BASIC,
  PLAN_YI_ANNUAL_BASIC,
  PLAN_YI_ANNUAL_PREMIUM,
  PLAN_YI_MONTHLY_PREMIUM,
  PLAN_YI_ANNUAL_WINBACK,
  PLAN_YI_THREE_MONTH_TO_MONTHLY_BASIC,
  PLAN_G_1M_ARP,
  PLAN_G_1M_AIP,
  PLAN_G_3M_N25,
  PLAN_MONTHLY_N26,
} from 'services/plans'
import {
  setUserBillingSubscriptionProcessing,
  setUserBillingSubscriptionData,
  setUserBillingSubscriptionError,
  GET_USER_PAYMENT_HISTORY_DATA,
  setUserPaymentHistoryProcessing,
  setUserPaymentHistoryData,
  setUserPaymentHistoryDataError,
  CREATE_USER_REFUND,
  setUserRefundProcessing,
  setUserRefundData,
  setUserRefundDataError,
  CREATE_USER_REFUND_CANCEL,
  setUserRefundCancelProcessing,
  setUserRefundCancelData,
  setUserRefundCancelDataError,
  CREATE_USER_COMP,
  setUserCompProcessing,
  setUserCompData,
  setUserCompDataError,
  CREATE_USER_CANCEL_SUBSCRIPTION,
  setUserCancelSubscriptionProcessing,
  setUserCancelSubscriptionData,
  setUserCancelSubscriptionError,
  CREATE_USER_REACTIVATE_SUBSCRIPTION,
  setUserReactivateSubscriptionProcessing,
  setUserReactivateSubscriptionData,
  setUserReactivateSubscriptionError,
  GET_PLANS,
  setPlansProcessing,
  setPlansData,
  setPlansError,
  CREATE_USER_PLAN_CHANGE,
  setUserPlanChangeProcessing,
  setUserPlanChangeData,
  setUserPlanChangeError,
  CREATE_USER_UPDATE_PAYMENT_METHOD,
  setUserUpdatePaymentMethodProcessing,
  setUserUpdatePaymentMethodData,
  setUserUpdatePaymentMethodError,
  CREATE_USER_REFUND_DOWNGRADE,
  setUserRefundDowngradeProcessing,
  setUserRefundDowngradeData,
  setUserRefundDowngradeDataError,
  CREATE_USER_REMOVE_PAYMENT_METHODS,
  setUserRemovePaymentMethodsProcessing,
  setUserRemovePaymentMethodsData,
  setUserRemovePaymentMethodsError,
  CREATE_USER_ADJUST_PRICE,
  setUserAdjustPriceProcessing,
  setUserAdjustPriceData,
  setUserAdjustPriceError,
} from './actions'
import {
  getUserBillingSubscriptionDetails,
  getUserPaymentHistory,
  createUserRefund,
  createUserRefundCancel,
  createRefundDowngrade,
  createUserComp,
  createUserCancelSubscription,
  createUserReactivateSubscription,
  getPlans,
  changePlan,
  updatePaymentMethod,
  createUserRemovePaymentMethods,
  createUserAdjustPrice,
} from '../..'

const log = console

async function setUserHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = payload.data.get('billing_account_id')
  const billingAccountNumber = payload.data.get('billing_account_number')

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }
  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserBillingSubscriptionProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
      }),
    )

    const billingData = await getUserBillingSubscriptionDetails(options)
    billingData.payload = payload
    store.dispatch(
      setUserBillingSubscriptionData({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
        data: fromJS(billingData),
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting billing and subscription data for user.')
    store.dispatch(
      setUserBillingSubscriptionError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

const billingSubscriptionError = (error) => {
  const errorBody = JSON.parse(_get(error, ['response', 'text']))
  let title = _get(errorBody, ['errors', 0, 'title'])
  let detail = _get(errorBody, ['errors', 0, 'detail'])
  const errorCode = _get(errorBody, ['errorCode'], null)

  if (errorCode && errorCode === 'PAYMENT_ERROR') {
    const errorMessage = JSON.parse(_get(errorBody, ['message']))
    title = 'Payment Error'
    detail = `${_get(errorMessage, ['gatewayResponse', 'message'])}, Code ${_get(errorMessage, ['gatewayResponse', 'code'])}`
  }

  if (errorCode && errorCode === 'POSTAL_CODE_ERROR') {
    title = 'Postal Code Error'
    detail = 'Please enter a valid postal code.'
  }

  const err = `${title}: ${detail}`
  return err
}

async function getUserPaymentHistoryHandler ({ store }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserPaymentHistoryProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENTS,
      }),
    )

    const paymentHistoryData = await getUserPaymentHistory(options)
    store.dispatch(
      setUserPaymentHistoryData({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENTS,
        data: fromJS(paymentHistoryData),
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting payment history data for user.')
    store.dispatch(
      setUserPaymentHistoryDataError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PAYMENTS,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserRefundHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const { paymentId } = payload
  const { amount } = payload
  const { reason } = payload

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
      paymentId,
      amount,
      reason,
    }
    store.dispatch(
      setUserRefundProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND,
      }),
    )

    const refundData = await createUserRefund(options)
    if (refundData.success) {
      store.dispatch(
        setUserRefundData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND,
          data: fromJS(refundData),
        }),
      )
    } else {
      store.dispatch(
        setUserRefundDataError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND,
          error: refundData.errors ? refundData.errors[0].message : 'Unable to process refund.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error creating refund for user.')
    store.dispatch(
      setUserRefundDataError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserRefundCancelHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const { paymentId } = payload
  const { amount } = payload
  const { reason } = payload

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
      paymentId,
      amount,
      reason,
    }
    store.dispatch(
      setUserRefundCancelProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL,
      }),
    )

    const refundData = await createUserRefundCancel(options)

    if (refundData.success) {
      store.dispatch(
        setUserRefundCancelData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL,
          data: fromJS(refundData),
        }),
      )
    } else {
      store.dispatch(
        setUserRefundCancelDataError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL,
          error: refundData.errors
            ? refundData.errors[0].message
            : 'Unable to process refund and cancel.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error creating refund and cancel for user.')
    store.dispatch(
      setUserRefundCancelDataError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_CANCEL,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserRefundDowngradeHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const { paymentId, nextRatePlanId, reason, prorate } = payload

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
      paymentId,
      nextRatePlanId,
      reason,
      prorate,
    }
    store.dispatch(
      setUserRefundDowngradeProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
      }),
    )

    const refundDowngradeData = await createRefundDowngrade(options)

    if (refundDowngradeData.success) {
      store.dispatch(
        setUserRefundDowngradeData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
          data: fromJS(refundDowngradeData),
        }),
      )

      if (refundDowngradeData.errors.length > 0) {
        store.dispatch(
          setUserRefundDowngradeDataError({
            storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
            success: true,
            error: refundDowngradeData.errors
              ? refundDowngradeData.errors[0].message
              : 'Unable to process downgrade.',
            data: fromJS(refundDowngradeData),
          }),
        )
      }
    } else {
      store.dispatch(
        setUserRefundDowngradeDataError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
          success: false,
          error: refundDowngradeData.errors
            ? refundDowngradeData.errors[0].message
            : 'Unable to process refund and downgrade.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error creating refund and downgrade for user.')
    store.dispatch(
      setUserRefundDowngradeDataError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REFUND_DOWNGRADE,
        success: false,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserCompHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const { reason } = payload
  const { duration } = payload

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
      reason,
      duration,
    }
    store.dispatch(
      setUserCompProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP,
      }),
    )

    const compData = await createUserComp(options)

    if (compData.success) {
      store.dispatch(
        setUserCompData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP,
          data: fromJS(compData),
        }),
      )
    } else {
      store.dispatch(
        setUserCompDataError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP,
          error: compData.errors ? compData.errors[0].message : 'Unable to process comp.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error creating comp for user.')
    store.dispatch(
      setUserRefundDataError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_COMP,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserCancelSubscriptionHandler ({ store }) {
  const { config, auth, userBillingSubscription } = store.getState()

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserCancelSubscriptionProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL,
      }),
    )

    const cancelData = await createUserCancelSubscription(options)

    if (cancelData.success) {
      store.dispatch(
        setUserCancelSubscriptionData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL,
          data: fromJS(cancelData),
        }),
      )
    } else {
      store.dispatch(
        setUserCancelSubscriptionError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL,
          error: cancelData.errors ? cancelData.errors[0].message : 'Unable to process comp.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error creating comp for user.')
    store.dispatch(
      setUserCancelSubscriptionError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_CANCEL,
        error: billingSubscriptionError(error),
      }),
    )
  }
}
async function createUserReactivateSubscriptionHandler ({ store }) {
  const { config, auth, userBillingSubscription } = store.getState()

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  const nextRatePlanId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'plan',
    'productRatePlanId',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
      nextRatePlanId,
    }
    store.dispatch(
      setUserReactivateSubscriptionProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE,
      }),
    )

    const reactivateData = await createUserReactivateSubscription(options)

    if (reactivateData.success) {
      store.dispatch(
        setUserReactivateSubscriptionData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE,
          data: fromJS(reactivateData),
        }),
      )
    } else {
      store.dispatch(
        setUserReactivateSubscriptionError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE,
          error: reactivateData.errors
            ? reactivateData.errors[0].message
            : 'Unable to reactivate user',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error reactivating user.')
    store.dispatch(
      setUserReactivateSubscriptionError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REACTIVATE,
        error: billingSubscriptionError(error),
      }),
    )
  }
}
async function getPlansHandler ({ store }) {
  const { config, user } = store.getState()
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const enableArcPlans = config.getIn(['data', 'features', 'enableArcPlans'])
  const enableZuoraPlans = config.getIn(['data', 'features', 'enableNewZuoraPlans'])
  if (!server) {
    return
  }
  try {
    const yogaInternationalUserId = user.getIn(['userDetail', 'data', 'yoga_international_user_id'])
    const skus = yogaInternationalUserId
      ? [
          PLAN_YI_ONE_WEEK_TRIAL_TO_MONTHLY_BASIC,
          PLAN_YI_ONE_WEEK_TRIAL_TO_ANNUAL_BASIC,
          PLAN_YI_MONTHLY_BASIC,
          PLAN_YI_ANNUAL_BASIC,
          PLAN_YI_ANNUAL_PREMIUM,
          PLAN_YI_MONTHLY_PREMIUM,
          PLAN_YI_ANNUAL_WINBACK,
          PLAN_YI_THREE_MONTH_TO_MONTHLY_BASIC,
        ]
      : [
          PLAN_THREE_MONTH,
          PLAN_DISCOUNTED_LIVE_ACCESS,
          PLAN_COMP,
          PLAN_DECLINE_303,
          PLAN_SUMMIT_ANNUAL,
          PLAN_SUMMIT_ANNUAL_2,
          PLAN_SUMMIT_ANNUAL_3,
          PLAN_SUMMIT_MONTHLY,
          PLAN_ONE_DOLLAR_THIRTY_DAYS_TO_MONTHLY,
          PLAN_ONE_MONTH_TRIAL_TO_ANNUAL,
          PLAN_SEVEN_DAY_MONTHLY_FREE_TRIAL_N24,
          PLAN_MONTHLY_N24,
          PLAN_SEVEN_DAY_ANNUAL_FREE_TRIAL_N24,
          PLAN_ANNUAL_N24,
          PLAN_LIVE_ACCESS_N24,
          PLAN_G_1M_ARP,
          PLAN_G_1M_AIP,
        ]

    if (enableArcPlans && !yogaInternationalUserId) {
      skus.push(PLAN_G_3M_N25)
    }

    if (enableZuoraPlans) {
      skus.push(PLAN_MONTHLY_N26, PLAN_ANNUAL_N26)
    }

    const language = 'en'
    const options = { skus, language, server }
    store.dispatch(setPlansProcessing({ storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS }))
    const plansData = await getPlans(options)
    if (_size(plansData) > 0 && _get(plansData, [0, 'sku'])) {
      store.dispatch(
        setPlansData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS,
          data: fromJS(plansData),
        }),
      )
    } else {
      store.dispatch(
        setUserCancelSubscriptionError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS,
          error: plansData.errors ? plansData.errors[0].message : 'Unable to fetch plans.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error fetching plans.')
    store.dispatch(
      setPlansError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLANS,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserChangePlanHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const { nextRatePlanId, planSku } = payload
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      nextRatePlanId,
      planSku,
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserPlanChangeProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE,
      }),
    )

    const changePlanData = await changePlan(options)

    if (changePlanData.success) {
      store.dispatch(
        setUserPlanChangeData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE,
          data: fromJS(changePlanData),
        }),
      )
    } else {
      store.dispatch(
        setUserPlanChangeError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE,
          error: changePlanData.errors
            ? changePlanData.errors[0].message
            : 'Unable to change plan.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error trying to change plan for the user.')
    store.dispatch(
      setUserPlanChangeError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_PLAN_CHANGE,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserUpdatePaymentMethodHandler ({ store, action }) {
  const { config, auth, userBillingSubscription } = store.getState()
  const { payload } = action
  const paymentMethodId = _get(payload, 'paymentMethodId')
  const country = _get(payload, 'country')
  const postalCode = _get(payload, 'postalCode')
  const server = config.getIn(['data', 'servers', 'brooklyn'])
  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])

  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      paymentMethodId,
      country,
      postalCode,
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserUpdatePaymentMethodProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT,
      }),
    )

    const updatePaymentData = await updatePaymentMethod(options)

    if (updatePaymentData.success) {
      store.dispatch(
        setUserUpdatePaymentMethodData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT,
          data: fromJS(updatePaymentData),
        }),
      )
    } else {
      store.dispatch(
        setUserUpdatePaymentMethodError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT,
          error: updatePaymentData.errors
            ? updatePaymentData.errors[0].message
            : 'Unable to update payment method.',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error trying to update payment method for the user.')
    store.dispatch(
      setUserUpdatePaymentMethodError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_UPDATE_PAYMENT,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

async function createUserRemovePaymentMethodsHandler ({ store }) {
  const { config, auth, userBillingSubscription } = store.getState()

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  const billingAccountId = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountId',
  ])
  const billingAccountNumber = userBillingSubscription.getIn([
    STORE_KEY_USER_BILLING_SUBSCRIPTION_SUBSCRIPTION,
    'data',
    'billingAccountNumber',
  ])
  try {
    const options = {
      auth,
      server,
      billingAccountId,
      billingAccountNumber,
    }
    store.dispatch(
      setUserRemovePaymentMethodsProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS,
      }),
    )

    const removePaymentMethodData = await createUserRemovePaymentMethods(options)

    if (removePaymentMethodData.success) {
      store.dispatch(
        setUserRemovePaymentMethodsData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS,
          data: fromJS(removePaymentMethodData),
        }),
      )
    } else {
      store.dispatch(
        setUserRemovePaymentMethodsError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS,
          error: removePaymentMethodData.errors
            ? removePaymentMethodData.errors[0].message
            : 'Unable to process payment methods removal',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error removing payment methods for user.')
    store.dispatch(
      setUserRemovePaymentMethodsError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_REMOVE_PAYMENT_METHODS,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

/**
 * Redux middleware handler for adjusting user subscription price
 *
 * This middleware handles the price adjustment process by:
 * 1. Validating authentication and server configuration
 * 2. Dispatching processing state
 * 3. Making the API call to adjust price
 * 4. Handling success/error responses
 *
 * @async
 * @param {Object} params - The middleware parameters
 * @param {Object} params.store - Redux store instance containing:
 *   - config: Server configuration
 *   - auth: Authentication state
 *   - userBillingSubscription: User's subscription data
 *
 * @fires setUserAdjustPriceProcessing - When the adjustment process starts
 * @fires setUserAdjustPriceData - On successful price adjustment
 * @fires setUserAdjustPriceError - On failed price adjustment
 *
 * @example
 * // Called by Redux middleware when adjust price action is dispatched
 * createUserAdjustPriceHandler({ store })
 */
async function createUserAdjustPriceHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action

  const server = config.getIn(['data', 'servers', 'brooklyn'])
  if (!auth.getIn(['data', 'jwt']) || !server) {
    return
  }

  try {
    const options = {
      auth,
      server,
      ...payload,
    }
    store.dispatch(
      setUserAdjustPriceProcessing({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
      }),
    )

    const adjustPriceData = await createUserAdjustPrice(options)

    if (adjustPriceData.success) {
      store.dispatch(
        setUserAdjustPriceData({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
          data: fromJS(adjustPriceData),
        }),
      )
    } else {
      store.dispatch(
        setUserAdjustPriceError({
          storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
          error: adjustPriceData.errors
            ? adjustPriceData.errors[0].message
            : 'Unable to process adjust price',
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error adjusting price for user.')
    store.dispatch(
      setUserAdjustPriceError({
        storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
        error: billingSubscriptionError(error),
      }),
    )
  }
}

// Redux middleware for user/billing-subscription
export default (store) => (next) => (action) => {
  const { type } = action

  switch (type) {
    case SET_USER:
      setUserHandler({ store, action })
      break
    case GET_USER_PAYMENT_HISTORY_DATA:
      getUserPaymentHistoryHandler({ store })
      break
    case CREATE_USER_REFUND_CANCEL:
      createUserRefundCancelHandler({ store, action })
      break
    case CREATE_USER_REFUND:
      createUserRefundHandler({ store, action })
      break
    case CREATE_USER_REFUND_DOWNGRADE:
      createUserRefundDowngradeHandler({ store, action })
      break
    case CREATE_USER_COMP:
      createUserCompHandler({ store, action })
      break
    case CREATE_USER_CANCEL_SUBSCRIPTION:
      createUserCancelSubscriptionHandler({ store })
      break
    case CREATE_USER_REACTIVATE_SUBSCRIPTION:
      createUserReactivateSubscriptionHandler({ store })
      break
    case GET_PLANS:
      getPlansHandler({ store })
      break
    case CREATE_USER_PLAN_CHANGE:
      createUserChangePlanHandler({ store, action })
      break
    case CREATE_USER_UPDATE_PAYMENT_METHOD:
      createUserUpdatePaymentMethodHandler({ store, action })
      break
    case CREATE_USER_REMOVE_PAYMENT_METHODS:
      createUserRemovePaymentMethodsHandler({ store, action })
      break
    case CREATE_USER_ADJUST_PRICE:
      createUserAdjustPriceHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
